import React from 'react'
const Ratings = ({ rating }) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (i <= rating) {
            stars.push(
                <i class="ri-star-fill"></i>
            )
        }
        else if (i === Math.ceil(rating) && !Number.isInteger(rating)) {
            stars.push(
                <i class="ri:star-half-fill"></i>
            )
        } else {
            stars.push(
                <i class="ri-star-line"></i>
            )
        }





    }
    return (
        <div className='flex mt-1 ml-2 800px:mt-0 800px:ml-0'>{stars}</div>
    )
}

export default Ratings